/**
 * Legacy route. The Qualitas declaration used to be its own verification
 * step so every KYC user signed it without answering PEP/income questions.
 *
 * That split produced two Qualitas cards and a second, nested copy of the
 * same text whose checkbox could not be tapped. The declaration now lives
 * on the AML screen — the only place the insurer actually needs it — and
 * this path just takes anyone with an old link there.
 */
import { useEffect } from 'react'
import { ActivityIndicator, View } from 'react-native'
import { useRouter } from 'expo-router'
import { ScreenContainer } from '@/components/ui/ScreenContainer'

export default function VerificationDisclaimerScreen() {
  const router = useRouter()

  useEffect(() => {
    router.replace('/profile/verification/compliance')
  }, [router])

  return (
    <ScreenContainer scroll={false}>
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        <ActivityIndicator />
      </View>
    </ScreenContainer>
  )
}
